// src/context/MediaQueryContext.js
import React, { createContext, useContext } from 'react';
import { useTheme, useMediaQuery } from '@mui/system';

const ThemeContext = createContext();

export const ThmeProvider = ({ children }) => {
  const theme = useTheme();
//   xs, extra-small: 0px
// sm, small: 600px
// md, medium: 900px
// lg, large: 1200px
// xl, extra-large: 1536px
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isSM = useMediaQuery(theme.breakpoints.between('xs','sm'));
  const isMD = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.between('xl'));
  

  return (
    <ThemeContext.Provider value={{isXs, isSM,isSm,isMD,isMd,isLg,isXl}}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('ThemeContext must be used when raped component in ThemeContext.Provider');
  }
  return context;
};
